module.exports = __webpack_public_path__ + "roboto-latin-ext-100-normal.woff2";